




import utils from "@/utils.js"

export default {
    "name": "MyFlag",
    "props": {
        lang: String
    }
    "computed": {
        "getFlag": () ->
            return utils.languageMapping(@lang)
    }
}
